import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";

import { Button } from "@mui/material";

import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import ConfirmationDialog from "../ConfirmationDialog";
import "../CommonDashboard.css";
import TableStatus from "../TableStatus";

const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      width: "100%",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const ResolutionTable = ({ selectedOption, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const resolutionData = useSelector((state) => state?.resolution?.resolutions);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const loggedInUser = useSelector((state) => state.user.user);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const columns = [
    {
      field: "name",
      headerName: "Alias",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "value",
      headerName: "Screen size in pixels",
      flex: 1,
      minWidth: 170,
    },

    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params.row.id)}
          disabled={
            loading ||
            (loggedInUser?.customProperties?.admin ?? "false") == "false"
          }
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  const handleEdit = (id) => {
    setSelectedItemId(id);
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "resolution",
      query: { id: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== deleteItemId
          );
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (resolutionData) setRows(resolutionData);
  }, [resolutionData]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

           
            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
              />
            )}
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default ResolutionTable;
